import { DownloadTemplateState } from 'common/models/data/downloadTemplate.model';

const initialDownloadTemplateState: DownloadTemplateState = {
    downloadFileStatus: {},
    downloadFile: undefined
};

export default initialDownloadTemplateState;
